/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateEarningCardRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {UpdateEarningCardResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const updateEarningCard = (request: UpdateEarningCardRequest, options?: CashRequestOptions) => post<UpdateEarningCardRequest, UpdateEarningCardResponse>("/2.0/cash/update-earning-card", request, {...options, rejectOnError: true })